const PERMISSION_KEY= "personalize:portfolio_wallet";
const PAGE_URL = {
    PORTFOLIO_WALLET_PAGE: "/admin/personalize/portfolio-wallet"
}

export {PERMISSION_KEY, PAGE_URL}

